var _typeof = require('./typeof.js')['default'];
var toPrimitive = require('./toPrimitive.js');
function toPropertyKey(t) {
    var i = toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports['default'] = module.exports;